import axios from "axios";
import {
  GET_ERRORS,
  FORGOT_PASSWORD_REQUEST,
  VERIFY_CODE_SUCCESS,
  RESET_PASSWORD_SUCCESS,
} from "./types";

// Step 1: Send Verification Code to User's Email
export const sendVerificationCode = (email) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/users/forgot-password`,
      null,
      {
        params: { email }, // Passing email as a query parameter
      }
    );
    dispatch({
      type: FORGOT_PASSWORD_REQUEST,
      payload: res.data, // The response from the server (probably success message)
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response
        ? err.response.data
        : "Failed to send verification code",
    });
  }
};

// Step 2: Verify Code sent to User's Email
// Step 2: Verify Code sent to User's Email
export const verifyCode = (email, code) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/users/verify`,
      { email, code }, // JSON body, matches @RequestBody
      { headers: { "Content-Type": "application/json" } }
    );
    dispatch({
      type: VERIFY_CODE_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response
        ? err.response.data
        : "Invalid verification code",
    });
  }
};


// Step 3: Reset the Password
// Step 3: Reset the Password
export const resetPassword = (email, newPassword) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/users/reset-password`,
      null,
      {
        params: { email, newPassword }, // Send email and newPassword as query parameters
      }
    );
    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      payload: res.data, // The response from the server, e.g., "Password reset successfully."
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response
        ? err.response.data.message
        : "Failed to reset password",
    });
  }
};

// Action to clear success and error messages
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";

export const clearMessages = () => {
  return {
    type: CLEAR_MESSAGES,
  };
};
